var _defs, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatshappening(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3500 2000",
    style: {
      enableBackground: "new 0 0 3500 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3500,
    height: 2000
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F6FD"
    },
    d: "M623.742,1821.227h2351.647c38.678-59.628,43.717-150.153,24.597-218.607 s-68.715-127.782-132.694-158.736c-54.064-26.157-118.367-33.571-163.536-73.155c-55.265-48.431-64.981-128.843-87.929-198.651 c-57.884-176.082-233.235-310.696-418.56-307.58c-168.339,2.83-315.427,106.655-457.476,197.032 c-142.049,90.377-309.555,173.904-472.435,131.29c-45.378-11.872-88.011-33.207-133.879-43.018 c-142.098-30.395-298.931,72.421-327.73,214.85c-21.406,105.865,15.874,231.439-54.637,313.255 C706.136,1730.091,629.867,1752.611,623.742,1821.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCE6FF"
    },
    d: "M2624.24,349.55c-33.993-8.761-68.185-11.239-101.74-4.696 c-172.805,33.698-103.037,221.237-156.482,334.997c-12.186,25.938-28.762,49.873-48.935,70.24 c-68.739,69.402-137.811,112.332-135.77,221.215c1.622,86.522,48.21,172.033,116.693,224.037 c59.935,45.514,137.571,66.473,212.324,59.278c85.405-8.22,117.978-66.538,165.675-130.114 c74.564-99.387,171.358-57.211,275.516-84.682c75.011-19.784,132.499-89.365,145.912-164.63 c25.081-140.746-71.44-244.022-168.962-328.35C2850.403,479.341,2738.441,378.984,2624.24,349.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M2495.404,1256.512c-66.26,0-131.845-21.481-183.582-60.77 c-70.51-53.545-115.299-139.54-116.89-224.427c-1.703-90.863,46.21-136.111,101.688-188.503 c11.168-10.547,22.717-21.453,34.226-33.073c20.077-20.27,36.509-43.855,48.839-70.101c17.93-38.165,22.021-85.326,25.979-130.934 c3.888-44.814,7.908-91.154,25.231-127.991c9.332-19.846,21.683-35.484,37.758-47.81c18.014-13.812,40.215-23.148,67.871-28.54 c31.624-6.165,65.93-4.584,101.961,4.702c109.117,28.124,215.725,120.524,293.566,187.992c3.689,3.198,7.313,6.338,10.865,9.41 c80.499,69.608,112.057,113.058,130.556,143.134c37.389,60.786,50.005,121.522,38.571,185.682 c-6.625,37.175-24.371,73.883-49.971,103.36c-26.725,30.773-60.026,52.096-96.305,61.666c-34.121,8.999-67.32,10.53-99.428,12.01 c-33.081,1.525-64.327,2.966-93.818,12.379c-33.102,10.565-59.157,29.665-81.997,60.109c-5.343,7.121-10.535,14.23-15.556,21.105 c-39.93,54.671-74.413,101.887-150.472,109.207C2514.817,1256.052,2505.098,1256.512,2495.404,1256.512z M2575.533,341.68 c-13.325,0-26.281,1.22-38.817,3.664c-27.501,5.363-49.565,14.637-67.454,28.353c-15.944,12.226-28.198,27.744-37.462,47.442 c-17.247,36.675-21.26,82.925-25.14,127.651c-3.965,45.696-8.064,92.947-26.07,131.273c-12.378,26.349-28.875,50.028-49.032,70.38 c-11.521,11.632-23.076,22.544-34.25,33.096c-55.306,52.229-103.07,97.336-101.375,187.757 c1.585,84.588,46.223,170.285,116.495,223.648c59.108,44.887,136.378,66.463,211.975,59.179 c75.611-7.277,109.973-54.324,149.76-108.801c5.022-6.878,10.217-13.989,15.563-21.115c50.316-67.067,111.643-69.895,176.57-72.888 c32.055-1.478,65.201-3.006,99.218-11.978c36.084-9.518,69.213-30.733,95.806-61.354c25.482-29.343,43.147-65.88,49.741-102.88 c11.389-63.907-1.185-124.414-38.438-184.982c-18.462-30.015-49.963-73.383-130.358-142.901c-3.553-3.072-7.176-6.213-10.866-9.411 c-77.767-67.403-184.271-159.714-293.161-187.779C2616.641,344.468,2595.668,341.68,2575.533,341.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCE6FF"
    },
    d: "M1096.328,454.151c-74.805-52.801-170.59-64.92-233.954,10.791 c-45.16,53.96-59.037,129.261-115.196,174.98c-61.891,50.385-151.515,49.082-210.795,102.782 c-89.15,80.764-114.748,233.683-46.106,334.26c83.071,121.719,309.504,204.315,452.175,190.252 c127.016-12.52,235.649-106.406,275.25-226.699c30.067-91.335,22.031-190.186,6.043-283.395 c-14.141-82.437-23.896-188.807-77.457-256.442C1133.062,483.979,1115.893,467.961,1096.328,454.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M890.89,1261.306c-64.642,0-142.831-16.359-215.985-45.772 c-44.013-17.696-83.782-38.907-118.203-63.044c-36.892-25.869-65.747-53.856-85.761-83.182 c-32.859-48.147-45.716-110.267-36.201-174.916c9.213-62.596,39.241-120.914,82.384-159.998c30.702-27.812,70.17-41.125,108.338-54 c35.707-12.045,72.63-24.5,102.477-48.798c32.285-26.283,50.909-63.057,68.92-98.62c13.293-26.248,27.039-53.39,46.208-76.293 c29.445-35.183,68.318-53.767,112.438-53.767c0.214,0,0.42,0,0.634,0.001c39.428,0.159,82.596,15.39,121.554,42.888 c19.489,13.756,36.8,29.88,50.063,46.627c46.117,58.235,59.722,144.539,71.725,220.684c1.978,12.55,3.847,24.405,5.833,35.984 c9.509,55.433,14.039,100.708,14.257,142.483c0.274,52.619-6.372,98.79-20.317,141.154 c-40.675,123.556-151.461,214.796-275.676,227.04C913.169,1260.801,902.234,1261.306,890.89,1261.306z M955.505,403.915 c-43.818,0-82.421,18.459-111.671,53.409c-19.095,22.816-32.815,49.906-46.083,76.103c-18.058,35.656-36.731,72.526-69.181,98.943 c-29.987,24.413-66.997,36.897-102.789,48.97c-77.439,26.123-92.969,40.19-107.986,53.794 c-42.975,38.932-72.887,97.032-82.066,159.402c-9.479,64.399,3.32,126.267,36.038,174.206 c19.946,29.227,48.716,57.127,85.509,82.928c34.358,24.093,74.06,45.267,118.002,62.935 c85.849,34.518,178.635,51.031,248.202,44.175c123.827-12.206,234.27-103.172,274.823-226.357 c31.814-96.642,19.931-202.088,6.025-283.155c-1.987-11.585-3.857-23.443-5.835-35.998 c-11.984-76.023-25.566-162.189-71.521-220.218c-13.204-16.673-30.443-32.729-49.855-46.431 c-38.792-27.381-81.757-42.547-120.981-42.705C955.925,403.915,955.714,403.915,955.505,403.915z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA714"
    },
    d: "M636.018,915.807l413.672-162.473c2.859-1.123,6.104-0.574,8.435,1.428l42.741,36.708 L623.742,981.446l7.074-58.909C631.179,919.508,633.178,916.922,636.018,915.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB841"
    },
    d: "M623.742,981.446l2.5,69.466c0.152,4.233,4.446,7.041,8.385,5.485l509.14-201.185 c3.893-1.538,5.136-6.438,2.447-9.646l-45.347-54.096L623.742,981.446z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 8.2257 1134.4343)",
    style: {
      fill: "#F3F6FD"
    },
    cx: 1373.496,
    cy: 557.288,
    rx: 55.317,
    ry: 55.317
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7531 -0.6579 0.6579 0.7531 -737.7303 910.8298)",
    style: {
      fill: "#F3F6FD"
    },
    cx: 844.575,
    cy: 1438.245,
    rx: 19.466,
    ry: 19.466
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 730.9807 2609.1255)",
    style: {
      fill: "#F3F6FD"
    },
    cx: 2013.877,
    cy: 842.746,
    rx: 16.358,
    ry: 16.358
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 240.9515 1728.0621)",
    style: {
      fill: "#F3F6FD"
    },
    cx: 2206.431,
    cy: 573.177,
    rx: 79.657,
    ry: 79.657
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 19.9873 2448.9202)",
    style: {
      fill: "#F3F6FD"
    },
    cx: 2966.102,
    cy: 1200.333,
    rx: 45.762,
    ry: 45.762
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3F6FD"
    },
    cx: 2452.16,
    cy: 1577.384,
    r: 20.332
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3F6FD"
    },
    cx: 1368.023,
    cy: 998.429,
    r: 30.227
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -712.8211 2547.9307)",
    style: {
      fill: "#F3F6FD"
    },
    cx: 1140.956,
    cy: 1692.876,
    rx: 30.503,
    ry: 30.503
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCE6FF"
    },
    d: "M1719.231,195.281c18.272-8.334,39.59-10.735,63.95-7.196c32.004,4.649,57.483,16.159,76.435,34.53 c18.948,18.37,26.244,42.568,21.883,72.59c-2.675,18.411-9.517,33.252-20.529,44.522c-6.479,6.868-18.207,15.142-35.19,24.822 l-16.737,9.499c-9.121,5.182-15.638,11.827-19.554,19.935c-0.354,0.734-0.701,1.531-1.041,2.39 c-5.017,12.687-17.866,20.458-31.368,18.497l-0.393-0.057c-17.652-2.564-28.832-20.282-23.595-37.333 c2.073-6.749,4.211-12.02,6.415-15.812c4.998-8.601,15.984-17.742,32.961-27.424l17.223-9.862 c5.637-3.085,10.34-6.666,14.105-10.748c6.776-6.967,10.846-15.127,12.204-24.474c1.563-10.761-0.155-21.026-5.156-30.791 c-5.001-9.762-15.839-15.857-32.508-18.279c-16.39-2.381-28.806,1.384-37.241,11.292c-3.615,4.248-6.612,8.665-8.991,13.25 c-5.757,11.096-17.652,17.585-30.023,15.788l-4.028-0.585c-19.278-2.8-30.583-23.493-22.16-41.059 C1685.681,218.369,1700.126,203.87,1719.231,195.281z M1748.571,443.352l5.995,0.871c15.884,2.307,26.89,17.055,24.583,32.939 l-0.562,3.87c-2.307,15.884-17.054,26.89-32.939,24.583l-5.995-0.871c-15.884-2.307-26.89-17.054-24.583-32.939l0.562-3.87 C1717.939,452.051,1732.687,441.044,1748.571,443.352z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1754.091,511.729c-1.409,0-2.834-0.101-4.269-0.31l-5.996-0.871 c-7.814-1.135-14.719-5.246-19.442-11.574c-4.723-6.329-6.699-14.117-5.563-21.931l0.562-3.871 c2.343-16.132,17.373-27.355,33.505-25.006l5.996,0.871c16.131,2.343,27.348,17.374,25.005,33.505l-0.562,3.871 C1781.192,501.11,1768.526,511.729,1754.091,511.729z M1748.62,448.857c-13.948,0-26.185,10.258-28.248,24.459l-0.562,3.871 c-1.097,7.55,0.813,15.075,5.375,21.189c4.563,6.114,11.234,10.085,18.784,11.183l5.996,0.871 c15.584,2.266,30.108-8.575,32.372-24.16l0.562-3.871c2.265-15.585-8.573-30.107-24.159-32.372l-5.996-0.871 C1751.359,448.955,1749.981,448.857,1748.62,448.857z M1765.495,420.983c-1.402,0-2.818-0.101-4.24-0.308l-0.392-0.056 c-8.548-1.242-16.099-6.141-20.719-13.44c-4.629-7.314-5.826-16.256-3.283-24.535c2.075-6.755,4.249-12.11,6.461-15.917 c5.019-8.637,16.17-17.925,33.145-27.606l17.224-9.862c5.576-3.052,10.279-6.635,13.986-10.653 c6.681-6.869,10.741-15.01,12.076-24.207c1.541-10.607-0.177-20.866-5.106-30.492c-4.9-9.566-15.712-15.627-32.135-18.012 c-16.132-2.341-28.51,1.398-36.788,11.122c-3.573,4.199-6.577,8.625-8.928,13.157c-5.913,11.396-18.184,17.845-30.539,16.052 l-4.028-0.585c-9.443-1.372-17.438-6.997-21.934-15.432c-4.428-8.307-4.648-17.906-0.605-26.338 c9.793-20.423,24.457-35.139,43.583-43.737c18.279-8.337,39.885-10.77,64.227-7.235c31.961,4.643,57.771,16.306,76.711,34.666 c18.983,18.405,26.396,42.973,22.03,73.021c-2.678,18.433-9.631,33.505-20.666,44.799c-6.479,6.868-18.358,15.25-35.3,24.907 l-16.737,9.5c-8.987,5.105-15.498,11.739-19.352,19.718c-0.35,0.726-0.695,1.519-1.026,2.357 C1788.537,413.558,1777.529,420.982,1765.495,420.983z M1773.581,244.217c2.884,0,5.908,0.229,9.075,0.689 c16.761,2.435,27.824,8.674,32.881,18.545c5.025,9.815,6.777,20.275,5.206,31.091c-1.367,9.41-5.519,17.737-12.341,24.75 c-3.771,4.089-8.561,7.738-14.224,10.838l-17.216,9.858c-16.819,9.593-27.847,18.758-32.776,27.24 c-2.174,3.741-4.317,9.025-6.369,15.708c-2.457,7.999-1.301,16.639,3.172,23.706c4.464,7.053,11.76,11.786,20.018,12.985 l0.392,0.056c13.165,1.92,25.842-5.566,30.831-18.186c0.34-0.86,0.695-1.675,1.056-2.423c3.943-8.166,10.591-14.946,19.758-20.153 l16.736-9.5c16.855-9.606,28.655-17.927,35.074-24.73c10.89-11.146,17.75-26.032,20.396-44.25 c4.316-29.713-2.996-53.991-21.735-72.16c-18.787-18.211-44.411-29.782-76.16-34.395c-24.146-3.507-45.567-1.099-63.67,7.157 l-0.002,0.001c-18.905,8.499-33.403,23.053-43.091,43.258c-3.904,8.141-3.69,17.412,0.586,25.435 c4.345,8.152,12.07,13.587,21.195,14.913l4.028,0.585c11.934,1.732,23.792-4.505,29.508-15.524 c2.386-4.598,5.432-9.087,9.054-13.344C1751.843,248.287,1761.445,244.217,1773.581,244.217z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CB597"
    },
    d: "M840.001,1593.332c-72.727-60.359-170.953-88.917-264.705-76.958 c26.998,27.208,57.083,50.971,88.07,73.533c15.495,11.282,31.623,22.04,49.545,28.837 C754.876,1634.657,805.673,1622.243,840.001,1593.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CB597"
    },
    d: "M866.143,1604.454c43.86-59.858,111.418-101.841,184.509-114.661 c-9.237,31.082-22.745,61.273-39.135,89.251c-15.753,26.892-37.454,53.827-68.014,59.948 C914.75,1644.752,888.025,1623.978,866.143,1604.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CB597"
    },
    d: "M678.303,1364.961c26.402,82.529,86.164,153.852,162.797,194.293 c9-48.424-1.647-101.137-35.275-137.124C771.508,1385.405,726.892,1377.83,678.303,1364.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CB597"
    },
    d: "M862.917,1564.881c-18.87-68.475,0.802-146.241,49.962-197.506 c10.45,30.295,18.507,67.202,18.723,99.247c0.15,22.257-2.624,45.646-15.459,63.831 C902.84,1549.303,883.99,1555.489,862.917,1564.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M858.941,1697.685l-19.908-138.032c-6.494-26.734-27.274-71.225-89.347-131.507 c-37.29-36.215-72.253-61.224-72.602-61.472c-0.946-0.674-1.167-1.986-0.493-2.933c0.673-0.945,1.986-1.167,2.933-0.493 c0.351,0.25,35.534,25.413,73.049,61.839c62.901,61.074,83.972,106.402,90.571,133.673l0.037,0.194l15.461,107.201 c-0.158-32.67,0.01-81.851,2.185-101.505c3.373-30.486,48.124-191.021,50.027-197.84c0.312-1.119,1.468-1.771,2.591-1.46 c1.119,0.313,1.772,1.473,1.46,2.591c-0.465,1.667-46.562,167.023-49.898,197.172c-3.339,30.185-1.897,131.224-1.882,132.24 L858.941,1697.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M856.191,1727.331l-17.198-125.843c-0.61-4.468-3.363-8.363-7.363-10.421 c-26.273-13.522-78.975-30.365-152.408-48.708c-55.564-13.879-103.868-23.828-104.349-23.927 c-1.138-0.233-1.871-1.345-1.637-2.482c0.233-1.138,1.343-1.873,2.482-1.637c0.483,0.099,48.86,10.063,104.507,23.962 c74.804,18.685,126.391,35.188,153.328,49.053c5.219,2.685,8.81,7.766,9.606,13.59l12.346,90.347l8.615-87.734l0.497-0.523 c16.104-16.97,178.091-111.036,184.979-115.032c1.004-0.584,2.291-0.242,2.874,0.764c0.583,1.004,0.241,2.291-0.764,2.873 c-1.666,0.967-165.151,95.899-183.544,113.791L856.191,1727.331z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M796.356,1658.52H916.87c5.483,0,9.596,5.016,8.52,10.393l-28.175,140.868 c-1.22,6.098-6.574,10.487-12.793,10.487h-54.792c-6.191,0-11.529-4.351-12.778-10.415l-29.008-140.892 C786.736,1663.571,790.853,1658.52,796.356,1658.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB841"
    },
    cx: 2641.709,
    cy: 811.022,
    r: 191.166
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCA714"
    },
    cx: 2641.709,
    cy: 811.022,
    r: 150.502
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB841"
    },
    d: "M2713.156,823.272c-5.681-8.389-13.677-14.681-23.987-18.875c7.865-3.67,13.894-9.085,18.088-16.253 c4.195-7.164,6.292-15.029,6.292-23.594c0-8.561-1.487-15.86-4.457-21.89c-2.974-6.029-7.038-10.879-12.191-14.549 c-5.156-3.67-11.142-6.333-17.958-7.996c-0.269-0.065-0.543-0.121-0.814-0.184v-19.178h-25.134v16.872h-17.566v-16.872h-25.134 v16.872h-36.213h-7.332v29.885h27.517v127.407h-27.517v29.885h7.332h36.213v16.872h25.134v-16.872h17.566v16.872h25.134v-18.435 c2.14-0.407,4.249-0.885,6.32-1.452c7.34-2.007,13.763-5.153,19.268-9.438c5.505-4.281,9.872-9.7,13.108-16.253 c3.232-6.554,4.85-14.374,4.85-23.463C2721.676,841.451,2718.833,831.661,2713.156,823.272z M2680.78,769.53 c0,7.775-2.49,13.436-7.471,16.975c-4.981,3.539-11.142,5.309-18.482,5.309h-24.643v-44.304h23.07c3.67,0,7.164,0.348,10.486,1.036 c3.318,0.692,6.247,1.901,8.782,3.629c2.532,1.729,4.543,4.014,6.03,6.865C2680.035,761.891,2680.78,765.385,2680.78,769.53z  M2683.271,860.891c-1.835,3.236-4.326,5.813-7.472,7.734c-3.145,1.925-6.73,3.236-10.748,3.932 c-4.022,0.701-8.127,1.049-12.321,1.049h-22.808v-51.906h22.808c4.367,0,8.561,0.438,12.583,1.311 c4.018,0.877,7.557,2.359,10.617,4.457c3.055,2.097,5.505,4.85,7.34,8.258c1.835,3.408,2.752,7.648,2.752,12.715 C2686.023,853.51,2685.105,857.659,2683.271,860.891z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M3251.219,1825.618H297.632c-2.954,0-5.349-2.396-5.349-5.35s2.395-5.35,5.349-5.35h2953.586 c2.954,0,5.35,2.396,5.35,5.35S3254.173,1825.618,3251.219,1825.618z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M2538.947,1166.138c0,0,25-51.457,30.283-58.325c5.283-6.868,59.172-40.681,59.172-40.681 s5.283,10.566,2.642,16.906c-2.642,6.34-26.416,34.869-26.416,34.869l66.04-14.265c0,0,67.097-36.982,71.852-32.756 c4.755,4.226,1.258,82.684-15.321,94.251c-13.405,9.352-122.042,21.98-122.042,21.98l-23.676,21.789L2538.947,1166.138z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_17_",
    style: {
      overflow: "visible",
      fill: "#FFC0B1"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000178203083387352823330000010792931496106997426_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000178203083387352823330000010792931496106997426_)",
      fill: "#102A54"
    },
    d: "M2658.479,1130.581 c-1.074,0-2.077-0.677-2.442-1.75c-0.458-1.35,0.264-2.814,1.612-3.272l34.546-11.729c1.495-0.387,2.879-1.014,4.778-2.165 l46.967-27.068c1.235-0.711,2.811-0.288,3.522,0.946s0.288,2.812-0.946,3.522l-46.918,27.039 c-2.242,1.361-4.063,2.179-6.016,2.694l-34.273,11.645C2659.033,1130.536,2658.753,1130.581,2658.479,1130.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000178203083387352823330000010792931496106997426_)",
      fill: "#102A54"
    },
    d: "M2665.9,1149.249 c-1.074,0-2.077-0.677-2.442-1.75c-0.458-1.349,0.264-2.813,1.612-3.272l34.546-11.729c1.495-0.387,2.879-1.014,4.778-2.165 l46.967-27.068c1.234-0.711,2.811-0.288,3.522,0.946s0.288,2.812-0.946,3.522l-46.918,27.039 c-2.242,1.361-4.063,2.179-6.016,2.694l-34.273,11.646C2666.455,1149.204,2666.175,1149.249,2665.9,1149.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000178203083387352823330000010792931496106997426_)",
      fill: "#102A54"
    },
    d: "M2670.57,1168.156 c-1.104,0-2.126-0.715-2.466-1.826c-0.416-1.362,0.351-2.804,1.713-3.221l34.891-10.661c1.507-0.341,2.909-0.925,4.841-2.017 l47.778-25.611c1.255-0.674,2.82-0.2,3.492,1.055c0.673,1.256,0.2,2.819-1.055,3.492l-47.728,25.583 c-2.281,1.29-4.126,2.052-6.097,2.507l-34.615,10.586C2671.074,1168.119,2670.82,1168.156,2670.57,1168.156z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M2641.36,1165.37c-0.421,0-0.848-0.104-1.242-0.321l-25.394-13.986l-12.492-31.196 c-0.529-1.322,0.113-2.824,1.436-3.354c1.321-0.529,2.824,0.113,3.354,1.436l11.807,29.485l23.778,13.098 c1.248,0.687,1.702,2.256,1.015,3.503C2643.151,1164.888,2642.27,1165.37,2641.36,1165.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M1053.33,1166.632c0,0-25-51.457-30.283-58.325c-5.283-6.868-59.172-40.681-59.172-40.681 s-5.283,10.566-2.642,16.906c2.642,6.34,26.416,34.869,26.416,34.869l-66.04-14.265c0,0-67.097-36.982-71.852-32.756 s4.755,81.781,15.321,94.251s122.042,21.98,122.042,21.98l23.676,21.789L1053.33,1166.632z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_16_",
    style: {
      overflow: "visible",
      fill: "#FFC0B1"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000034051445246966154060000000778919290241832607_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000034051445246966154060000000778919290241832607_)",
      fill: "#102A54"
    },
    d: "M928.507,1131.276 c-0.259,0-0.522-0.039-0.783-0.122l-29.513-9.392l-51.068-31.565c-1.212-0.749-1.587-2.339-0.838-3.551 c0.749-1.211,2.338-1.585,3.55-0.838l50.527,31.231l28.906,9.198c1.357,0.433,2.107,1.883,1.676,3.24 C930.615,1130.575,929.6,1131.276,928.507,1131.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000034051445246966154060000000778919290241832607_)",
      fill: "#102A54"
    },
    d: "M925.08,1149.781 c-0.184,0-0.37-0.02-0.557-0.062l-33.338-7.333l-51.17-31.629c-1.212-0.749-1.587-2.339-0.838-3.551 c0.749-1.212,2.339-1.585,3.55-0.838l50.424,31.168l32.481,7.146c1.391,0.306,2.271,1.682,1.965,3.072 C927.331,1148.96,926.264,1149.781,925.08,1149.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000034051445246966154060000000778919290241832607_)",
      fill: "#102A54"
    },
    d: "M917.808,1167.923 c-0.184,0-0.37-0.02-0.557-0.062l-33.338-7.333l-51.17-31.629c-1.212-0.749-1.587-2.339-0.838-3.551s2.339-1.586,3.55-0.838 l50.424,31.168l32.481,7.146c1.391,0.306,2.271,1.682,1.965,3.072C920.059,1167.102,918.992,1167.923,917.808,1167.923z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M950.917,1165.864c-0.91,0-1.792-0.482-2.262-1.336c-0.687-1.247-0.233-2.816,1.015-3.503 l23.778-13.098l11.807-29.485c0.53-1.321,2.031-1.966,3.354-1.436c1.322,0.529,1.965,2.031,1.435,3.354l-12.492,31.196 l-25.392,13.986C951.765,1165.761,951.338,1165.864,950.917,1165.864z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M2538.411,1139.013l-287.477,238.563l-216.212-223.005v0.001 c-24.369-35.859-65.487-59.417-112.111-59.417h-260.166c-18.703,0-36.52,3.79-52.725,10.645 c-20.604,8.715-37.979,22.233-51.316,38.809l-0.003-0.033l-219.465,232.999l-287.477-238.563l-70.741,69.406l256.866,310.446 c19.574,23.657,47.021,39.462,77.307,44.516h0c34.617,5.777,70.084-2.959,98.058-24.152l144.591-118.003l7.988,399.042h489.79 l1.733-371.853l119.869,90.813c27.974,21.193,63.442,29.929,98.058,24.152l0,0c30.286-5.054,57.733-20.859,77.307-44.516 l256.866-310.446L2538.411,1139.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C203F"
    },
    d: "M1651.804,1095.57c0,0,37.447,227.05,153.849,344.556c0,0,93.459-127.174,98.336-344.556H1651.804z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0B1"
    },
    d: "M1763.428,1154.571L1763.428,1154.571c-31.93,0-57.095-27.197-54.62-59.031l14.829-190.745h77.442 l16.918,190.136C1820.849,1126.978,1795.601,1154.571,1763.428,1154.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0B1"
    },
    d: "M1669.744,726.88l234.863,0.335l1.206,15.283c4.168,52.84,13.163,105.234,27.751,156.191 c6.98,24.38,11.565,54.23,4.363,80.72c-14.127,51.964-65.978,85.048-118.544,73.36 C1766.394,1040.987,1689.082,990.474,1669.744,726.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1827.969,888.717c-1.188,0-2.258-0.827-2.519-2.036c-0.3-1.392,0.585-2.765,1.978-3.065 l22.115-4.769c1.911-0.412,3.482-1.664,4.312-3.434c0.828-1.77,0.783-3.779-0.124-5.511l-34.123-65.125 c-0.661-1.262-0.175-2.821,1.087-3.482c1.262-0.661,2.82-0.174,3.481,1.087l34.124,65.126c1.662,3.172,1.744,6.85,0.226,10.092 c-1.518,3.242-4.396,5.535-7.895,6.289l-22.115,4.769C1828.332,888.698,1828.149,888.717,1827.969,888.717z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3411 -0.94 0.94 0.3411 403.8033 2215.4238)",
    style: {
      fill: "#102A54"
    },
    cx: 1782.142,
    cy: 819.683,
    rx: 12.439,
    ry: 12.439
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1880.518,795.958c1.448,6.716-2.822,13.334-9.537,14.782c-6.716,1.448-13.334-2.822-14.782-9.537 c-1.448-6.716,2.822-13.334,9.537-14.782C1872.452,784.972,1879.07,789.242,1880.518,795.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1834.789,929.069h-26.755c-1.425,0-2.579-1.155-2.579-2.579c0-1.424,1.154-2.579,2.579-2.579 h26.755c7.879,0,15.621-1.382,23.013-4.109l11.094-4.092c1.333-0.491,2.819,0.19,3.313,1.527c0.493,1.336-0.19,2.819-1.527,3.313 l-11.094,4.092C1851.622,927.58,1843.278,929.069,1834.789,929.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1831.771,1057.288c-0.089,0-0.178-0.004-0.269-0.014c-1.527-0.158-37.759-4.13-67.054-26.57 c-1.131-0.866-1.346-2.485-0.479-3.616c0.866-1.132,2.485-1.346,3.616-0.479c28.106,21.531,64.089,25.498,64.449,25.535 c1.416,0.147,2.445,1.415,2.298,2.832C1834.195,1056.302,1833.076,1057.288,1831.771,1057.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1692.688,782.454c0,0,21.612,83.518,4.371,101.131c-17.241,17.613-29.408-6.484-29.408-6.484 s-47.076-80.045-5.327-109.005C1687.902,750.352,1692.688,782.454,1692.688,782.454z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9775 -0.2108 0.2108 0.9775 -148.1055 372.9023)",
    style: {
      fill: "#FFC0B1"
    },
    cx: 1674.997,
    cy: 881.121,
    rx: 27.381,
    ry: 40.133
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1651.8,788.835c0,0-93-98.657-19.439-149.979c73.561-51.322,251.982-35.925,251.982-35.925 c7.338-18.454,26.9-28.253,46.711-29.644s40.165,10.553,47.63,28.956c7.466,18.403,0.652,41.819-16.096,52.492 c17.917,3.073,27.264,26.212,20.138,42.935c-7.126,16.724-25.922,26.154-44.078,27.063c10.261,8.776,9.867,26.031,1.479,36.611 c-8.388,10.58-22.551,15.16-36.052,15.336c-13.501,0.176-26.718-3.44-39.87-6.495c-58.044-13.481-118.531-16.365-177.594-8.468 C1670.32,763.896,1658.262,773.723,1651.8,788.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1743.887,802.083c-2.258,0-4.495-0.988-6.015-2.889c-2.656-3.319-2.118-8.163,1.202-10.818 c19.433-15.546,51.099-10.054,52.436-9.813c4.184,0.754,6.963,4.757,6.208,8.94c-0.754,4.18-4.752,6.955-8.929,6.21 c-0.12-0.021-6.925-1.195-15.441-0.827c-7.365,0.319-17.622,1.88-24.657,7.508 C1747.271,801.532,1745.574,802.083,1743.887,802.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1838.911,894.836c0,0-30.647-3.55-44.327,3.551c-13.68,7.101-24.884,28.104-24.884,28.104 l134.288-21.695c0,0-16.753-15.804-29.065-18.658C1862.611,883.284,1838.911,894.836,1838.911,894.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102A54"
    },
    d: "M1697.055,886.165c-1.218,0-2.302-0.867-2.533-2.108c-4.779-25.7-29.399-22.33-30.444-22.172 c-1.402,0.212-2.721-0.758-2.934-2.165c-0.213-1.406,0.75-2.719,2.156-2.935c0.306-0.046,30.592-4.332,36.293,26.328 c0.261,1.4-0.664,2.747-2.064,3.007C1697.37,886.151,1697.211,886.165,1697.055,886.165z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1708.808,1095.156l54.62,59.031l-60.782,26.971c-13.007,5.772-27.649-3.75-27.649-17.98v-68.022 H1708.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1817.997,1094.931l-29.537,53.607l36.104,23.743c13.799,9.075,32.155-0.823,32.155-17.339v-60.01 H1817.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6515C"
    },
    d: "M1788.46,1148.538L1788.46,1148.538c-1.528-3.606-5.389-8.436-12.202-7.821 c-10.588,0.956-12.83,13.469-12.83,13.469l0,506.514l72.979,95.466l39.01-95.593L1788.46,1148.538z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatshappening);
export default __webpack_public_path__ + "static/media/whatshappening.6bb4034a9aed5d2729c0d3b3d0a9dec0.svg";
export { ForwardRef as ReactComponent };